import Message from "../../message";
import EventBus from "@/services/eventBus";

export default class BoutInviteReceived extends Message
{
    handle()
    {
        EventBus.emit('match-invite-received', this.message);
    }
}
